const comments = [
  {
    name: '影视爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Chinese%20person%20portrait%20avatar%2C%20warm%20lighting%2C%20simple%20clean%20background%2C%20professional%20casual%20style&width=80&height=80&seq=avatar-01-comment&orientation=squarish',
    text: '青青草视频真的太方便了！以前要在好几个网站之间来回切换找视频，现在一个页面就能直接看到久久视频、芒果视频、97视频的入口，省了好多时间。界面也很清爽，推荐给所有喜欢看视频的朋友。',
    time: '2天前',
  },
  {
    name: '追剧达人小李',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%20avatar%20with%20glasses%2C%20warm%20tone%2C%20clean%20simple%20background%2C%20modern%20casual%20style&width=80&height=80&seq=avatar-02-comment&orientation=squarish',
    text: '作为一个重度追剧用户，我每天要看久久视频的更新剧集和芒果视频的综艺节目。有了青青草视频，所有平台入口一目了然，还经常能看到最新的内容资讯，已经成了我的浏览器首页。',
    time: '3天前',
  },
  {
    name: '电影发烧友老张',
    avatar: 'https://readdy.ai/api/search-image?query=A%20middle-aged%20Chinese%20man%20portrait%20avatar%2C%20warm%20natural%20lighting%2C%20clean%20neutral%20background%2C%20professional%20casual%20look&width=80&height=80&seq=avatar-03-comment&orientation=squarish',
    text: '91在线视频的经典片库资源非常丰富，配合丝瓜视频的动漫频道，基本上满足了我们全家的观影需求。青青草视频的导航做得很用心，分类清晰，更新也及时。',
    time: '5天前',
  },
  {
    name: '数码博主阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20tech-savvy%20man%20portrait%20avatar%2C%20warm%20tone%2C%20minimalist%20clean%20background%2C%20modern%20stylish%20look&width=80&height=80&seq=avatar-04-comment&orientation=squarish',
    text: '蓝莓视频的高清画质确实惊艳，配合97视频的个性化推荐，我现在发现新内容的速度比以前快多了。青青草视频把这么多优质平台整合在一起，这个想法真的很棒。',
    time: '1周前',
  },
  {
    name: '休闲观众小陈',
    avatar: 'https://readdy.ai/api/search-image?query=A%20relaxed%20Chinese%20young%20adult%20portrait%20avatar%2C%20soft%20warm%20lighting%2C%20clean%20simple%20background%2C%20friendly%20casual%20style&width=80&height=80&seq=avatar-05-comment&orientation=squarish',
    text: '平时下班就想放松看看视频，但经常不知道哪个平台有什么好看的内容。青青草视频每天更新的热门榜单和话题推荐帮我解决了这个烦恼，直接跟着热度榜看就对了。',
    time: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-chat-smile-2-line"></i>
            用户评价
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            用户怎么说
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            真实用户反馈，看看大家为什么选择青青草视频
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.slice(0, 3).map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5 max-w-3xl mx-auto">
          {comments.slice(3).map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}